/**
 * The Vault's `files.file_type` vocabulary (labels under `fileUpload.fileTypes.*`)
 * and the extension → type guess both upload surfaces use: the inline
 * `VaultUploadCard` and the quick-add `UploadFileDialog`.
 */
export const VAULT_FILE_TYPES = [
  "document",
  "spreadsheet",
  "image",
  "video",
  "report",
  "sustainability",
  "compliance",
  "other",
] as const;

export type VaultFileType = (typeof VAULT_FILE_TYPES)[number];

const TYPE_BY_EXTENSION: Record<string, VaultFileType> = {
  pdf: "document",
  doc: "document",
  docx: "document",
  xls: "spreadsheet",
  xlsx: "spreadsheet",
  csv: "spreadsheet",
  jpg: "image",
  jpeg: "image",
  png: "image",
  gif: "image",
  mp4: "video",
  mov: "video",
  avi: "video",
};

/** Best-guess type from the file name's extension; `other` when unknown. */
export function guessVaultFileType(fileName: string): VaultFileType {
  const extension = fileName.includes(".") ? fileName.split(".").pop()?.toLowerCase() ?? "" : "";
  return TYPE_BY_EXTENSION[extension] ?? "other";
}

/** The file input's `accept` list — the extensions the Vault takes. */
export const VAULT_ACCEPTED_TYPES = Object.keys(TYPE_BY_EXTENSION).map((extension) => `.${extension}`);
